export const numberWithSpaces = (num) => {
    return Number(num).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}